import React, { useRef } from 'react';
import html2canvas from 'html2canvas';

const MyComponent = () => {
  const elementRefs = [
    useRef(null),
    useRef(null),
    // Add more refs for additional elements as needed
  ];

  const takeScreenshots = async () => {
    try {
      const canvasPromises = elementRefs.map(async (ref) => {
        if (ref.current) {
          return await html2canvas(ref.current);
        }
        return null;
      });

      const canvases = await Promise.all(canvasPromises);

      // Combine the screenshots into a single image
      const combinedCanvas = document.createElement('canvas');
      const context = combinedCanvas.getContext('2d');
      combinedCanvas.width = canvases.reduce((totalWidth, canvas) => totalWidth + canvas.width, 0);
      combinedCanvas.height = Math.max(...canvases.map(canvas => canvas.height));
      let offsetX = 0;
      canvases.forEach(canvas => {
        context.drawImage(canvas, offsetX, 0);
        offsetX += canvas.width;
      });

      // Convert the combined canvas to a data URL
      const imageDataURL = combinedCanvas.toDataURL();

      // Do something with the data URL (e.g., display it, save it, etc.)
      console.log('Combined screenshot data URL:', imageDataURL);
    } catch (error) {
      console.error('Error taking screenshots:', error);
    }
  };

  return (
    <div>
      <div ref={elementRefs[0]}>Element 1</div>
      <div ref={elementRefs[1]}>Element 2</div>
      {/* Add more elements with refs if needed */}
      <button onClick={takeScreenshots}>Take Screenshots</button>
    </div>
  );
};

export default MyComponent;
